import { useState } from "react";
import { connect } from "react-redux";
import LBODashboard from "./LBODashboard";
import DCFAnalysis from "./DCFAnalysis";
import DebtPanel from "./DebtPanel";
import SourcesAndUses from "./SourcesAndUses";
import DCFValuation from "./DCFValuation";
import DealOfferSummary from "./DealOfferSummary";
import BVASelect from "../../../components/BVASelect/BVASelect";
import InvalidBalAlert from "../../../components/BVAAlert/InvalidBalAlert";
import { updateDealType } from "../../../store/modules/dealOffer/actions";

const LBO_DASHBOARD = "LBO_DASHBOARD"
const DCF_ANALYSIS = "DCF_ANALYSIS"
const DEBT_PANEL = "DEBT_PANEL"
const SOURCES_AND_USES = "SOURCES_AND_USES"
const DCF_VALUATION = "DCF_VALUATION"
const DEAL_OFFER_SUMMARY = "DEAL_OFFER_SUMMARY"
const STOCK = "STOCK"
const ASSET = "ASSET"

const acquisitionsExpensesSections = [
  { label: "Leveraged Buyout(LBO) Dashboard", value: LBO_DASHBOARD },
  { label: "Advanced Discounted Cash Flow Analysis", value: DCF_ANALYSIS },
  { label: "Debt Assumptions", value: DEBT_PANEL },
  { label: "Sources And Uses", value: SOURCES_AND_USES },
  { label: "Discounted Cash Flow Valuation", value: DCF_VALUATION },
  { label: "Deal Offer Summary", value: DEAL_OFFER_SUMMARY }
]

const dealType = [
  { label: "Stock Purchase", value: STOCK },
  { label: "Asset Purchase", value: ASSET }
]

function DealOffer({ dispatchUpdateDealType }) {
  // State
  const [selectedSection, setSelectedSection] = useState(LBO_DASHBOARD)
  const [selectedDealType, setSelectedDealType] = useState(STOCK);

  const handleDealTypeOnChange = (dealType) => {
    dispatchUpdateDealType(dealType);
    setSelectedDealType(dealType);
  };

  return (
    <div>
      <InvalidBalAlert page={selectedSection} onLinkClick={() => setSelectedSection(LBO_DASHBOARD)} />
      <div className="flex items-center justify-between">
        <BVASelect
          items={acquisitionsExpensesSections}
          value={selectedSection}
          width="24em"
          placeholder="Select a section"
          onChange={(value) => setSelectedSection(value)} />
        <div className="ml-4">
          <BVASelect
            items={dealType}
            value={selectedDealType}
            width="10em"
            placeholder="Select a deal type"
            onChange={(value) => handleDealTypeOnChange(value)}
          />
        </div>
      </div>
      <div className="mt-10">
        {selectedSection === LBO_DASHBOARD ? (
          <LBODashboard dealType={selectedDealType} setSelectedDealType={setSelectedDealType} />
        ) : null}

        {selectedSection === DCF_ANALYSIS ? (
          <DCFAnalysis />
        ) : null}

        {selectedSection === DEBT_PANEL ? (
          <DebtPanel dealType={selectedDealType} />
        ) : null}

        {selectedSection === SOURCES_AND_USES ? (
          <SourcesAndUses dealType={selectedDealType} />
        ) : null}

        {selectedSection === DCF_VALUATION ? (
          <DCFValuation dealType={selectedDealType} />
        ) : null}

        {selectedSection === DEAL_OFFER_SUMMARY ? (
          <DealOfferSummary dealType={selectedDealType} />
        ) : null}
      </div>
    </div>
  )
}

const mapDispatchToProps = (dispatch) => ({
  async dispatchUpdateDealType(dealType) {
    await dispatch(updateDealType(dealType));
  },
});

export default connect(null, mapDispatchToProps)(DealOffer);